import { Routes } from "@angular/router";

export const BUILDPREFERENCES_CHILD_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'applicationproperties', 
    pathMatch: 'full'
  },
  {
    path: 'applicationproperties',
    loadComponent: () => import('../application-properties/application-properties.component').then((c) => c.ApplicationPropertiesComponent)
  },
  {
    path: 'plugins',
    loadComponent: () => import('../plugins/plugins.component').then((c) => c.PluginsComponent)
  },
  {
    path: 'sslpinning',
    loadComponent: () => import('../ssl-pinning/ssl-pinning.component').then((c) => c.SslPinningComponent)
  },
  {
    path: 'appicon',
    loadComponent: () => import('../app-icon/app-icon.component').then((c) => c.AppIconComponent)
  },
  {
    path: 'splashscreen',
    loadComponent: () => import('../splashscreens/splashscreens.component').then((c) => c.SplashscreensComponent)
  }
];